import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps {
  tone?: BadgeTone;
  /** Monospaced, for an IATA code or a flight number rather than a word. */
  code?: boolean;
  children: ReactNode;
}

/**
 * A tinted label for a state or a code.
 *
 * The tone is a hint, never the message: the text inside always says what the
 * state is, so a reader who cannot separate the tints — or is looking at a
 * printout — loses nothing.
 */
export const Badge = ({ tone = 'neutral', code = false, children }: BadgeProps) => (
  <span className={cx(styles.badge, styles[tone], code && styles.code)}>
    {children}
  </span>
);
